import BaseApi from '@/services/base.api.js';

class SpecificationApi extends BaseApi {
  async getAllSpecificationSelections() {
    let client = await this.getClient();
    return client({
      method: 'get',
      url: `${this.basicUrl}api/specification/getavailablespecificationselections`
    });
  }

  async getUnitsWithSpecifications() {
    let client = await this.getClient();
    return client({
      method: 'get',
      url: `${this.basicUrl}api/specification/getspecifications`
    });
  }

  async saveSpecification(data) {
    let client = await this.getClient();
    return client({
      method: 'POST',
      url: `${this.basicUrl}api/specification/createandassignspecs`,
      data: data
    });
  }

  async assignSpecification(data) {
    let { specGuid } = data;
    let client = await this.getClient();
    return client({
      method: 'PUT',
      url: `${this.basicUrl}api/specification/${specGuid}/assign`,
      data: data
    });
  }

  async deleteSpecification(specGuid) {
    let client = await this.getClient();
    return client({
      method: 'DELETE',
      url: `${this.basicUrl}api/specification/${specGuid}`,
      data: specGuid
    });
  }

  async getSingleSpecification(specGuid) {
    let client = await this.getClient();
    return client({
      method: 'GET',
      url: `${this.basicUrl}api/specification/${specGuid}`
    });
  }

  async updateSpecification(data) {
    let { specGuid } = data;
    let client = await this.getClient();
    return client({
      method: 'PUT',
      url: `${this.basicUrl}api/specification/${specGuid}`,
      data: data
    });
  }

  async unassignSpecification({ data }) {
    let client = await this.getClient();
    return client({
      method: 'PUT',
      url: `${this.basicUrl}api/specification/unassign`,
      data: data
    });
  }
}

export default SpecificationApi;
